import { Shield, Home, CheckCircle, LogOut, User } from "lucide-react";
import { Button } from "./ui/button";

interface RegistrationSlimHeaderProps {
    currentPage: 'register' | 'login' | 'admin' | 'tracking' | 'speaker-upload' | 'invite';
    isAuthenticated: boolean;
    userName?: string | null;
    onNavigate: (page: 'register' | 'login' | 'admin' | 'tracking' | 'speaker-upload' | 'invite') => void;
    onLogout: () => void;
}

export function RegistrationSlimHeader({ currentPage, isAuthenticated, onNavigate, onLogout }: RegistrationSlimHeaderProps) {
    return (
        <div className="w-full bg-[#0f2744] border-b-4 border-[#c9a227] shadow-lg">
            <div className="container mx-auto px-4 h-20 flex items-center justify-between">
                {/* Left: Branding */}
                <div className="flex items-center gap-4 cursor-pointer" onClick={() => onNavigate('register')}>
                    {/* Logo Shield */}
                    <div className="h-12 flex items-center justify-center">
                        <img
                            src={`${import.meta.env.BASE_URL}escudo-icono.svg`}
                            alt="UNACH"
                            className="h-12 w-auto object-contain filter brightness-0 invert"
                        />
                    </div>

                    {/* Titles */}
                    <div className="flex flex-col justify-center min-w-0">
                        <h1 className="text-white font-black text-sm sm:text-base md:text-xl tracking-tight leading-tight md:leading-none uppercase drop-shadow-sm whitespace-normal break-words">
                            CONVENCIÓN INTERNACIONAL <span className="text-[#c9a227]">UNACH</span>
                        </h1>
                        <span className="text-[9px] sm:text-[10px] md:text-xs text-gray-300 font-serif italic mt-0.5 tracking-wide leading-tight whitespace-normal">
                            "Ciencia, cultura y desarrollo con sentido humano"
                        </span>
                    </div>
                </div>

                {/* Right: Navigation (Upperbar) */}
                <div className="flex items-center gap-2 md:gap-4">
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => onNavigate('register')}
                        className={`gap-2 text-white hover:bg-[#1a3a5a] hover:text-[#c9a227] transition-colors ${currentPage === 'register' ? 'bg-[#1a3a5a] text-[#c9a227] ring-1 ring-[#c9a227]/30' : ''}`}
                    >
                        <Home className="h-4 w-4" />
                        <span className="hidden md:inline font-medium">Inicio</span>
                    </Button>

                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => onNavigate('tracking')}
                        className={`gap-2 text-white hover:bg-[#1a3a5a] hover:text-[#c9a227] transition-colors ${currentPage === 'tracking' ? 'bg-[#1a3a5a] text-[#c9a227]' : ''}`}
                    >
                        <CheckCircle className="h-4 w-4" />
                        <span className="hidden md:inline font-medium">Seguimiento</span>
                    </Button>

                    {isAuthenticated ? (
                        <>
                            <div className="h-6 w-px bg-white/20 mx-1 hidden md:block" />
                            <div className="flex items-center gap-2">
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={() => onNavigate('admin')}
                                    className="gap-2 text-white hover:bg-[#1a3a5a] hover:text-[#c9a227]"
                                >
                                    <Shield className="h-4 w-4" />
                                    <span className="hidden md:inline font-medium">Admin</span>
                                </Button>

                                <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={onLogout}
                                    className="gap-2 text-red-300 hover:bg-red-900/30 hover:text-red-200"
                                >
                                    <LogOut className="h-4 w-4" />
                                    <span className="hidden md:inline font-medium">Salir</span>
                                </Button>
                            </div>
                        </>
                    ) : (
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => onNavigate('login')}
                            className="gap-2 text-white hover:bg-[#1a3a5a] hover:text-[#c9a227] transition-colors"
                        >
                            <User className="h-4 w-4" />
                            <span className="hidden md:inline font-medium">Administración</span>
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}

